export enum ItemUrls {
   RANCH = '/ranch/',
   RANCH_AREA = '/ranch/area/',
   RANCH_LIST = '/ranch/list/',
   FARMING_LIST = '/farming/list/',
   PROCESS_FILE = '/ranch/files/'
}